/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  ApiAccordion,
  ApiAccordionFromJSON,
  ApiAccordionFromJSONTyped,
  ApiAccordionToJSON,
} from './ApiAccordion';
import {
  ApiAdTileSet,
  ApiAdTileSetFromJSON,
  ApiAdTileSetFromJSONTyped,
  ApiAdTileSetToJSON,
} from './ApiAdTileSet';
import { ApiBanner, ApiBannerFromJSON, ApiBannerFromJSONTyped, ApiBannerToJSON } from './ApiBanner';
import {
  ApiBannerCarousel,
  ApiBannerCarouselFromJSON,
  ApiBannerCarouselFromJSONTyped,
  ApiBannerCarouselToJSON,
} from './ApiBannerCarousel';
import {
  ApiNoContent,
  ApiNoContentFromJSON,
  ApiNoContentFromJSONTyped,
  ApiNoContentToJSON,
} from './ApiNoContent';
import {
  ApiProductCarousel,
  ApiProductCarouselFromJSON,
  ApiProductCarouselFromJSONTyped,
  ApiProductCarouselToJSON,
} from './ApiProductCarousel';
import {
  ApiShopNav,
  ApiShopNavFromJSON,
  ApiShopNavFromJSONTyped,
  ApiShopNavToJSON,
} from './ApiShopNav';
import {
  ApiSimpleItemCarouselGrid,
  ApiSimpleItemCarouselGridFromJSON,
  ApiSimpleItemCarouselGridFromJSONTyped,
  ApiSimpleItemCarouselGridToJSON,
} from './ApiSimpleItemCarouselGrid';
import {
  ApiSimpleItemCarouselItem,
  ApiSimpleItemCarouselItemFromJSON,
  ApiSimpleItemCarouselItemFromJSONTyped,
  ApiSimpleItemCarouselItemToJSON,
} from './ApiSimpleItemCarouselItem';
import {
  ApiStandardBanner,
  ApiStandardBannerFromJSON,
  ApiStandardBannerFromJSONTyped,
  ApiStandardBannerToJSON,
} from './ApiStandardBanner';
import {
  ApiStandardBannerCarousel,
  ApiStandardBannerCarouselFromJSON,
  ApiStandardBannerCarouselFromJSONTyped,
  ApiStandardBannerCarouselToJSON,
} from './ApiStandardBannerCarousel';
import {
  ApiStandardBlogCard,
  ApiStandardBlogCardFromJSON,
  ApiStandardBlogCardFromJSONTyped,
  ApiStandardBlogCardToJSON,
} from './ApiStandardBlogCard';
import {
  ApiStandardCard,
  ApiStandardCardFromJSON,
  ApiStandardCardFromJSONTyped,
  ApiStandardCardToJSON,
} from './ApiStandardCard';
import {
  ApiStandardContentBlock,
  ApiStandardContentBlockFromJSON,
  ApiStandardContentBlockFromJSONTyped,
  ApiStandardContentBlockToJSON,
} from './ApiStandardContentBlock';
import {
  ApiStandardNonSku,
  ApiStandardNonSkuFromJSON,
  ApiStandardNonSkuFromJSONTyped,
  ApiStandardNonSkuToJSON,
} from './ApiStandardNonSku';
import {
  ApiStandardPlaceholder,
  ApiStandardPlaceholderFromJSON,
  ApiStandardPlaceholderFromJSONTyped,
  ApiStandardPlaceholderToJSON,
} from './ApiStandardPlaceholder';
import {
  ApiStandardSiteWideBanner,
  ApiStandardSiteWideBannerFromJSON,
  ApiStandardSiteWideBannerFromJSONTyped,
  ApiStandardSiteWideBannerToJSON,
} from './ApiStandardSiteWideBanner';
import {
  ApiStandardSku,
  ApiStandardSkuFromJSON,
  ApiStandardSkuFromJSONTyped,
  ApiStandardSkuToJSON,
} from './ApiStandardSku';
import {
  ApiTileSet,
  ApiTileSetFromJSON,
  ApiTileSetFromJSONTyped,
  ApiTileSetToJSON,
} from './ApiTileSet';

/**
 * @type ApiZoneComponentsInner
 *
 * @export
 */
export type ApiZoneComponentsInner =
  | ApiAccordion
  | ApiAdTileSet
  | ApiBanner
  | ApiBannerCarousel
  | ApiNoContent
  | ApiProductCarousel
  | ApiShopNav
  | ApiSimpleItemCarouselGrid
  | ApiSimpleItemCarouselItem
  | ApiStandardBanner
  | ApiStandardBannerCarousel
  | ApiStandardBlogCard
  | ApiStandardCard
  | ApiStandardContentBlock
  | ApiStandardNonSku
  | ApiStandardPlaceholder
  | ApiStandardSiteWideBanner
  | ApiStandardSku
  | ApiTileSet;

export function ApiZoneComponentsInnerFromJSON(json: any): ApiZoneComponentsInner {
  return ApiZoneComponentsInnerFromJSONTyped(json, false);
}

export function ApiZoneComponentsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiZoneComponentsInner {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    ...ApiAccordionFromJSONTyped(json, true),
    ...ApiAdTileSetFromJSONTyped(json, true),
    ...ApiBannerFromJSONTyped(json, true),
    ...ApiBannerCarouselFromJSONTyped(json, true),
    ...ApiNoContentFromJSONTyped(json, true),
    ...ApiProductCarouselFromJSONTyped(json, true),
    ...ApiShopNavFromJSONTyped(json, true),
    ...ApiSimpleItemCarouselGridFromJSONTyped(json, true),
    ...ApiSimpleItemCarouselItemFromJSONTyped(json, true),
    ...ApiStandardBannerFromJSONTyped(json, true),
    ...ApiStandardBannerCarouselFromJSONTyped(json, true),
    ...ApiStandardBlogCardFromJSONTyped(json, true),
    ...ApiStandardCardFromJSONTyped(json, true),
    ...ApiStandardContentBlockFromJSONTyped(json, true),
    ...ApiStandardNonSkuFromJSONTyped(json, true),
    ...ApiStandardPlaceholderFromJSONTyped(json, true),
    ...ApiStandardSiteWideBannerFromJSONTyped(json, true),
    ...ApiStandardSkuFromJSONTyped(json, true),
    ...ApiTileSetFromJSONTyped(json, true),
  };
}

export function ApiZoneComponentsInnerToJSON(value?: ApiZoneComponentsInner | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    ...ApiAccordionToJSON(value),
    ...ApiAdTileSetToJSON(value),
    ...ApiBannerToJSON(value),
    ...ApiBannerCarouselToJSON(value),
    ...ApiNoContentToJSON(value),
    ...ApiProductCarouselToJSON(value),
    ...ApiShopNavToJSON(value),
    ...ApiSimpleItemCarouselGridToJSON(value),
    ...ApiSimpleItemCarouselItemToJSON(value),
    ...ApiStandardBannerToJSON(value),
    ...ApiStandardBannerCarouselToJSON(value),
    ...ApiStandardBlogCardToJSON(value),
    ...ApiStandardCardToJSON(value),
    ...ApiStandardContentBlockToJSON(value),
    ...ApiStandardNonSkuToJSON(value),
    ...ApiStandardPlaceholderToJSON(value),
    ...ApiStandardSiteWideBannerToJSON(value),
    ...ApiStandardSkuToJSON(value),
    ...ApiTileSetToJSON(value),
  };
}
